import { render, staticRenderFns } from "./industrial-park.vue?vue&type=template&id=1e9c6c9c&scoped=true"
import script from "./industrial-park.vue?vue&type=script&lang=js"
export * from "./industrial-park.vue?vue&type=script&lang=js"
import style0 from "./industrial-park.vue?vue&type=style&index=0&id=1e9c6c9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9c6c9c",
  null
  
)

export default component.exports